module.exports = __webpack_public_path__ + "img/item3.be682fd8.png";